import react, { useState, useEffect } from 'react';
import { Box, Typography, Chip, Checkbox, Stack, FormControlLabel, FormGroup } from '@mui/material';
import Grid from '@mui/material/Grid';
import SaveButton from '../Components/SaveButton';
import axios from 'axios';
import { APIURL } from '../../../config';
import moment from 'moment';

const ModulesActivated = (props) => {
    const [modules, setModules] = useState([]);
    const [originalModules, setOriginalModules] = useState([]);

    const handleCheckBoxChange = (event) => {
        if(event.target.checked){
            setModules([...modules, {feature_value: event.target.name, feature_id: props.moduleList.find((module) => module.feature_value === event.target.name).feature_id}]);
        } else {
            setModules(modules.filter((module) => module.feature_value !== event.target.name));
        }
    }

    const handleChipDelete = (module) => {
        setModules(modules.filter((m) => m.feature_value !== module.feature_value));
    }

    const handleSave = async () => {
        console.log(modules);
        try {
            let response = await axios.put(APIURL + "/config/settings/replace", {
                company_id: props.comp_id, 
                feature_value: "functionality",
                added_by: props.user_id,
                settings: modules.map((module) => {
                    return {
                        feature_id: module.feature_id,
                        feature_value: "functionality"
                    }
                })
            });

            if (modules.some((module) => module.feature_id === 14)) {
                await axios.post(APIURL + `/directories/initiate/${props.comp_id}`).then((res) => console.log(res)).catch((err) => console.log(err));
            }
            if (modules.some((module) => module.feature_id === 25)) {
                var data = {
                    is_default_for_private_payer: true,
                    prov_name: "Contract for Private Payers",
                    prov_iden: "999999",
                    prov_iden_type: 'NPI',
                    prov_iden_issuing_entity: 'NPI',
                    prov_iden_start_date: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    prov_iden_end_date: moment().add(10, 'years').format('YYYY-MM-DDTHH:mm:ss'),
                    prov_iden_company_id: props.comp_id,
                    prov_iden_status: 1,
                };
        
                const msg = await axios.post(APIURL + "/company/provider", data);
                console.log(msg);
        
                // if (newProviderDetails.medicaid_number) {
                //     var data = {
                //         prov_name: newProviderDetails.prov_name,
                //         prov_iden: newProviderDetails.medicaid_number,
                //         prov_iden_type: 'Medicaid',
                //         prov_iden_issuing_entity: 'Medicaid',
                //         prov_iden_start_date: newProviderDetails.prov_iden_start_date,
                //         prov_iden_end_date: newProviderDetails.prov_iden_end_date,
                //         prov_iden_company_id: props.comp_id,
                //         prov_iden_status: newProviderDetails.prov_iden_status,
                //     };
        
                //     const msg = await axios.post(APIURL + "/company/provider", data);
                // }
            } else {
                const msg = await axios.delete(APIURL + "/company/provider", { data: { comp_id: props.comp_id } });
                console.log(msg);
            }

            setOriginalModules(modules);
        } catch (error) {
            console.log(error);
        }   
    }

    useEffect(() => {
        setModules(props.selectedModules);
        setOriginalModules(props.selectedModules);
    }, [props.selectedModules]);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid size={props.leftColumnSize}>
                    <Stack spacing={1}>
                        <Typography variant="h5">
                            Modules Activated
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'gray' }}>
                            What modules are activated for your business?
                        </Typography>
                    </Stack>
                </Grid>
                <Grid size={props.rightColumnSize}>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            Modules
                        </Typography>
                        <Box sx={{ minHeight: 32 }}>
                            <Box sx={{ minHeight: 40 }}>
                                {modules.length === 0 && <Typography variant="body1" sx={{ color: 'gray' }}>No Modules selected</Typography>}
                                {modules.map((module, index) => {
                                    return (
                                        <Chip key={index} label={module.feature_value} onDelete={() => handleChipDelete(module)} color="primary" sx={{ mr: 1, mb: 1 }} />
                                    );
                                })}
                            </Box>
                            <Typography variant="h6">
                                Select Modules
                            </Typography>
                        </Box>
                        <FormGroup>
                            <Grid container spacing={0}>
                                {props.moduleList.map((module, index) => {
                                    return (
                                        <Grid size={4} key={index}>
                                            <FormControlLabel sx={{ height: 30 }} control={<Checkbox checked={modules.find((m) => m.feature_value === module.feature_value) ? true : false} onChange={handleCheckBoxChange} name={module.feature_value} />} label={module.feature_value} />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </FormGroup>
                        <SaveButton onClick={handleSave} disabled={JSON.stringify(modules) === JSON.stringify(originalModules)} />
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
    
}

export default ModulesActivated;